module.exports = __webpack_public_path__ + "img/remind.b71306ef.png";